module.exports = __webpack_public_path__ + "static/img/4.0ee1ae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newOne/4.png
// module id = Pp/w
// module chunks = 0